import { Divider } from '../../../Divider'
import { CountryType } from '../../types/CountryType'
import { AddressSection } from './components/AddressSection'
import { AdditionalInformationSection } from './components/AdditionalInformationSection'
import { BankAccountSection } from './components/BankAccountSection'

interface Props {
  countries: CountryType[]
}

export const FormContent = ({ countries }: Props) => {
  return (
    <>
      <BankAccountSection />
      <Divider sectionSeparator />
      <AddressSection countries={countries} />
      <Divider sectionSeparator />
      <AdditionalInformationSection countries={countries} />
    </>
  )
}
